import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appIsNew]',
  standalone: true,
})
export class IsNewDirective implements OnInit {
  @Input() executedTime!: Date;
  @Input() seconds!: number;
  private readonly defaultSeconds = 24 * 60 * 60 * 1000;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    const now = new Date();
    const diff = now.getTime() - new Date(this.executedTime).getTime();
    const seconds = this.seconds ?? this.defaultSeconds;

    if (diff < seconds) {
      const img = document.createElement('img');
      img.src = 'assets/core/table/new.svg';
      img.alt = 'New Icon';
      this.el.nativeElement.appendChild(img);
    }
  }
}
